<div class="table-responsive" [ngClass]="{'sk-loading': propertyService.spinnerShow}" [class.overflow-hidden]="propertyService.emptyRowService.emptyRow.length > 0">
    <table class="table table-striped table-hover footable">
        <thead>
            <tr [ngClass]="{'noSort': propertyService.data.length < 2}">
                <th></th>
                <th>ID</th>
                <th class="footable-sorted">Property Mgmt</th>
                <th (click)="propertyService.urlService.orderBy('name', $event)">
                    Property Name <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="propertyService.urlService.orderBy('corporationNumber', $event)">
                    Corporation # <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!propertyService.isShowView" (click)="propertyService.urlService.orderBy('address', $event)">
                    Address <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!propertyService.isShowView" (click)="propertyService.urlService.orderBy('createdAt', $event)">
                    Created On <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="!propertyService.isShowView">Created by</th>
                <th *ngIf="!propertyService.isShowView">Units</th>
                <th *ngIf="!propertyService.isShowView"
                    (click)="propertyService.urlService.orderBy('numberOfResidents', $event)">
                    Residents <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="propertyService.urlService.orderBy('numberOfUsers', $event)">
                    Users <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="propertyService.urlService.orderBy('numberOfEmails', $event)">
                    Emails <span class="footable-sort-indicator"></span>
                </th>
                <th (click)="propertyService.urlService.orderBy('numberOfInvitations', $event)">
                    Invitations <span class="footable-sort-indicator"></span>
                </th>
                <th *ngIf="propertyService.canDelete() && userIsSuperAdmin">Actions</th>
            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let item of propertyService.data" [ngClass]="{'footable-odd': (index % 2 === 0)}" (click)="toggleDetails(item)">
                <td>
                    <label class="img-checkbox">
                        <input type="checkbox" [ngModel]="item.checked">
                        <label><svg-checked></svg-checked></label>
                    </label>
                </td>
                <td>{{item.id}}</td>
                <td>{{item.companyName || '-'}}</td>
                <td>{{item.name}}</td>
                <td>{{item.corporationNumber ? item.corporationNumber.name : '-'}}</td>
                <td *ngIf="!propertyService.isShowView">{{item.address || '-'}}</td>
                <td *ngIf="!propertyService.isShowView">
                    {{item.createdAt ? propertyService.transformDate(item.createdAt) : '-'}}
                </td>
                <td *ngIf="!propertyService.isShowView">{{item.createdBy || '-'}}</td>
                <td *ngIf="!propertyService.isShowView">{{item.numberOfUnits || '-'}}</td>
                <td *ngIf="!propertyService.isShowView">{{item.numberOfResidents || '-'}}</td>
                <td>{{item.numberOfUsers || '-'}}</td>
                <td>{{item.numberOfEmails || '-'}}</td>
                <td>{{item.numberOfInvitations || '-'}}</td>
                <td class="td-action-btn" *ngIf="userIsSuperAdmin">
                    <div class="input-group-btn btn-in-table input-group">
                        <button *ngIf="propertyService.canDelete()"
                                (click)="removeItem(item, $event)"
                                class="btn btn-white btn-xs">
                            Delete
                        </button>
                    </div>
                </td>
            </tr>

            <tr *ngFor="let item of propertyService.emptyRowService.emptyRow" style="cursor: default;">
                <td></td>
                <td></td>
                <td>&nbsp;</td>
                <td></td>
                <td></td>
                <td *ngIf="!propertyService.isShowView"></td>
                <td *ngIf="!propertyService.isShowView"></td>
                <td *ngIf="!propertyService.isShowView"></td>
                <td *ngIf="!propertyService.isShowView"></td>
                <td *ngIf="!propertyService.isShowView"></td>
                <td></td>
                <td></td>
                <td></td>
                <td *ngIf="userIsSuperAdmin"></td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="propertyService.total === 0 && !propertyService.showServiceUnavailable" class="text-center">
        <h2>Result Not Found</h2>
        <a class="text-center">
            <broad-match-toggle></broad-match-toggle>
        </a>
    </div>
    <h2 *ngIf="propertyService.showServiceUnavailable" class="text-center">Service Unavailable</h2>
    <spinner [spinnerShow]="propertyService.spinnerShow"></spinner>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/property-list/property-list.component.html